/**
 * useSchoolsListScreen.js
 * -----------------------
 * Hook for School / College list screen using shared useMasterList and background JobEngine export.
 */
import { useMasterList } from '../../common/useMasterList';
import * as schoolsApi from '../api/schoolsApi';
import { useExportJob } from '../../../../hooks/useExportJob';

export function useSchoolsListScreen() {
  const master = useMasterList({
    entityName: 'School / College',
    apiClient: schoolsApi.schoolsClient,
    fetchList: schoolsApi.listSchools,
    archiveItem: schoolsApi.archiveSchool,
    deleteItem: schoolsApi.deleteSchool,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'schools',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
